/* eslint-disable no-new */
import EventClass from "common/utils/ui/event-class";

export class Redesign2025SubMasthead extends EventClass {
  event(event, $target) {
    super.event(event, $target);
    const { subCategory, subMenu } = $target.dataset;
    document.querySelectorAll(`[data-sub-menu="${subMenu}"]`).forEach($item => {
      const { baseClass, activeClass, subCategory: itemSubCategory } = $item.dataset;
      if (subCategory === itemSubCategory) $item.setAttribute("class", activeClass);
      else $item.setAttribute("class", baseClass);
    });
  }
}

export default () =>
  new Redesign2025SubMasthead({ eventSelector: ".js-redesign-2025-sub-menu", event: "mouseover" });
